import { createSlice } from '@reduxjs/toolkit';
import { IAction } from '../store';
import { IImportDocType } from './sliceImportDocTypes';

export enum ImportDialogStep {
    DoctypeSelection = 1,
    CategorySelection = 2,
    PackageSelection = 3,
    UploadProcess = 4,
}

export interface IImportDialogState {
    open: boolean;
    hidden: boolean;
    currentStep: ImportDialogStep;
    prevStep: ImportDialogStep;
    nextStep: ImportDialogStep;
    selectedDocType: IImportDocType | null;
    checkedCategories: string[];
    checkedPackages: string[];
    searchText: string;
}

const initialState: IImportDialogState = {
    open: false,
    hidden: false,
    currentStep: ImportDialogStep.DoctypeSelection,
    prevStep: ImportDialogStep.DoctypeSelection,
    nextStep: ImportDialogStep.DoctypeSelection,
    selectedDocType: null,
    checkedCategories: [],
    checkedPackages: [],
    searchText: '',
};

const reducers = {
    resetState(state: IImportDialogState) {
        Object.assign(state, initialState);
    },
    setIsOpen(state: IImportDialogState, action: IAction<boolean>) {
        state.open = action.payload;
        state.hidden = false;
    },
    setIsHidden(state: IImportDialogState, action: IAction<boolean>) {
        state.hidden = action.payload;
    },
    setStep(
        state: IImportDialogState,
        action: IAction<['prev' | 'current' | 'next', ImportDialogStep]>,
    ) {
        const [key, value] = action.payload;
        state[`${key}Step`] = value;
    },
    setSelectedDocType(state: IImportDialogState, action: IAction<IImportDocType>) {
        state.selectedDocType = action.payload;
    },
    setCategoryChecked(state: IImportDialogState, action: IAction<[string, boolean]>) {
        const [id, checked] = action.payload;
        state.checkedCategories = state.checkedCategories
            .slice()
            .filter(x => x !== id)
            .concat(checked ? id : []);
    },
    setPackageChecked(state: IImportDialogState, action: IAction<[string, boolean]>) {
        const [id, checked] = action.payload;
        state.checkedPackages = state.checkedPackages
            .slice()
            .filter(x => x !== id)
            .concat(checked ? id : []);
    },
    setSearchText(state: IImportDialogState, action: IAction<string>) {
        state.searchText = action.payload;
    },
};

export const importDialogSlice = createSlice({
    name: 'importDialog',
    initialState,
    reducers,
});

export const {
    resetState,
    setIsOpen,
    setIsHidden,
    setStep,
    setSelectedDocType,
    setCategoryChecked,
    setPackageChecked,
    setSearchText,
} = importDialogSlice.actions;

export default importDialogSlice.reducer;
